module.exports = __webpack_public_path__ + "static/img/Boolland_logo_white_full.144ad3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company/Boolland_logo_white_full.png
// module id = RbhO
// module chunks = 0